import React from 'react';
import './Microfinance.css';
import img13 from '../Assets/microfinanceImg1.webp'
import img14 from '../Assets/microfinanceImg2.jpg'
import img15 from '../Assets/microfinanceImg3.jpg'
import img16 from '../Assets/microfinanceImg4.jpg'

function Microfinance() {
  return (
    <div className="microfinance-container">
      <div className="microfinance-hero">
        <h1>Microfinance Initiatives</h1>
        <p>Empowering Women Entrepreneurs Through Financial Inclusion</p>
      </div>
      
      <div className="microfinance-content">
        <div className="microfinance-section">
          <div className='microfinanceflexbox'>
            <div className='microfinanceTextbox'>
              <h2>Women's Economic Empowerment</h2>
              <p>This project is dedicated to empowering women through microfinance initiatives that provide small loans and financial education to women entrepreneurs in underserved communities across Ghana.</p>
              <p>By offering access to capital and resources, the project aims to foster financial independence, improve living standards, and support the growth of small businesses run by women.</p>
              <p>Volunteers will work closely with local women to provide training in basic financial management, business planning, and savings strategies. The goal is to help these women develop sustainable businesses that can lift their families out of poverty and contribute to the economic development of their communities.</p>
              <p>Volunteers with skills in finance, business, education, or a passion for women's empowerment are encouraged to participate. Creativity, patience, and strong communication skills are highly valued, as volunteers will play a key role in guiding and inspiring these women to achieve their financial goals.</p>
              
            </div>
            
          </div>
        </div>
            <div className='microfinanceImgGrid'>
              <img src={img13} alt='Women entrepreneurs receiving financial training' className='microfinanceImg'/>
              <img src={img14} alt='Microfinance group meeting discussion' className='microfinanceImg'/>
              <img src={img15} alt='Business owner showcasing her products' className='microfinanceImg'/>
              <img src={img16} alt='Financial literacy workshop session' className='microfinanceImg'/>
            </div>
        
        

        
      </div>
        <div className="call-to-action">
          <h2>Help Build Financial Independence</h2>
          <p>Your expertise can transform lives and create sustainable communities</p>
          <a href='/VolunteerNow'><button className="cta-button">Support Women Entrepreneurs</button></a>
        </div>
    </div>
  );
}

export default Microfinance;